import { render, staticRenderFns } from "./Journals.vue?vue&type=template&id=dec85e68&scoped=true&"
import script from "./Journals.vue?vue&type=script&lang=js&"
export * from "./Journals.vue?vue&type=script&lang=js&"
import style0 from "./Journals.vue?vue&type=style&index=0&id=dec85e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec85e68",
  null
  
)

export default component.exports